import debug from 'debug';
import { BaseActions } from '@/models/Common/Actions/BaseActions';
import SearchAutoCompleteRequestBuilder from '@/models/SearchAutoComplete/SearchAutoCompleteRequestBuilder';
import { ISearchAutoCompleteSuggestionRequestParams } from '@/models/SearchAutoComplete/interfaces/ISearchAutoCompleteSuggestionRequestParams';
import { ResponseEither } from '@/models/Common/ResponseEither';
import { ISearchAutoCompleteSuggestionPayload } from '@/models/SearchAutoComplete/interfaces/payloads/ISearchAutoCompleteSuggestionPayload';
import { execAction } from '@/models/Common/Actions/handler';

const log = debug('sunny:SearchAutoCompleteActions');

export default class SearchAutoCompleteActions extends BaseActions<SearchAutoCompleteRequestBuilder> {
  trainSuggestions(
    params: ISearchAutoCompleteSuggestionRequestParams,
  ): Promise<ResponseEither<ISearchAutoCompleteSuggestionPayload>> {
    log('train suggestion list', params);
    return execAction('train suggestion list', this.requestBuilder.createGetSuggestionList(params));
  }
}
